import { useAppSelector } from "@/stores/hook";
import CreateApplication from "../education/AddApplicaiton/CreateApplication";
import DealPreview from "../videoProduction/nicheSideRoutes/Service/DealPreview/DealPreview";
import AcademyDealPreview from "../academy/nicheSideRoutes/Program/DealPreview/DealPreview";
import useCurrentIndustry from "@/hooks/globalapis/useCurrentIndustry";

export default function useIndexPageResolver() {
  const { industry } = useCurrentIndustry();

  const { startApplication } = useAppSelector((state) => state.educationSlice);
  const { showDealPreview } = useAppSelector(
    (state) => state.videoProductionFunctional
  );
  const { showDealPreview: showAcademyDealPreview } = useAppSelector(
    (state) => state.academyFunctional
  );

  if (industry?.id === 1) {
    if (startApplication) {
      return <CreateApplication />;
    }
  }

  if (industry?.id === 4) {
    if (showDealPreview) {
      return <DealPreview />;
    }
  }

  if (industry?.id === 5) {
    if (showAcademyDealPreview) {
      return <AcademyDealPreview />;
    }
  }

  return null;
}
